import { render, staticRenderFns } from "./filter-settings.vue?vue&type=template&id=4ff18fa8&scoped=true&"
import script from "./filter-settings.vue?vue&type=script&lang=js&"
export * from "./filter-settings.vue?vue&type=script&lang=js&"
import style0 from "./filter-settings.vue?vue&type=style&index=0&id=4ff18fa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff18fa8",
  null
  
)

export default component.exports